import React from 'react'
import { connect } from 'react-redux'
import * as actionCreator from '../../../redux/actions/data-action';
import connectCommon from '../../common/common-hoc';
import { 
    AssessmentContainer, 
    AssessmentBody, 
    AssessmentContent, 
    AssessmentNavigationPrevious, 
    AssessmentNavigationNext, 
    AssessmentFooter 
} from '../common';
import NextButton from '../../../assets/images/next@2x.png';

const PracticeComplete = ({previousLink, nextLink}) => (
    <AssessmentContainer> 
        <AssessmentBody>
            <AssessmentNavigationPrevious to={previousLink} />
            <AssessmentContent>
                <div>
                    Thank you for completing the practice question. You are now ready to begin the task.
                </div>
                <div>
                    Try to provide a response for each question even if you are unsure.
                </div>
                <br/>
                <div>
                    Click <img src={NextButton} alt="Next" style={{ height:'auto', width:'0.5em'}} /> to begin the task.
                </div>
            </AssessmentContent>
            <AssessmentNavigationNext to={nextLink} />
        </AssessmentBody>
        <AssessmentFooter></AssessmentFooter>
    </AssessmentContainer>
)

export default connect(null, actionCreator)(connectCommon(PracticeComplete));